/**
 * @generated SignedSource<<7b32d16565e53d49056c65c4b5831345>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type StorecastDeviceInfoStatus = "negative" | "positive" | "semiNegative";
import { FragmentRefs } from "relay-runtime";
export type InfoBoxScreen_StorecastScreen$data = {
  readonly id: string;
  readonly info: {
    readonly language: string | null;
    readonly languageStatus: StorecastDeviceInfoStatus;
    readonly resolution: string | null;
    readonly resolutionStatus: StorecastDeviceInfoStatus;
    readonly time: number | null;
    readonly timeStatus: StorecastDeviceInfoStatus;
    readonly timeZone: string | null;
    readonly timeZoneStatus: StorecastDeviceInfoStatus;
    readonly userAgentStatus: StorecastDeviceInfoStatus;
  };
  readonly " $fragmentType": "InfoBoxScreen_StorecastScreen";
};
export type InfoBoxScreen_StorecastScreen$key = {
  readonly " $data"?: InfoBoxScreen_StorecastScreen$data;
  readonly " $fragmentSpreads": FragmentRefs<"InfoBoxScreen_StorecastScreen">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InfoBoxScreen_StorecastScreen",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastDeviceInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "languageStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolution",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resolutionStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeZone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeZoneStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userAgentStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};

(node as any).hash = "b495b35643c95efeb55d2ecbfd123338";

export default node;
